<div class="phone_container">
    <ng-select
        class="phone_select"
        [notFoundText]="'NgSelect.NotFoundText' | translate"
        [(ngModel)]="selectedCountry"
        [items]="countries"
        bindLabel="name"
        [compareWith]="compareCountry"
        (ngModelChange)="onCountryChange()"
        [searchable]="true"
        [clearable]="false"
        [disabled]="isToConsult"
        >
        <ng-template ng-option-tmp let-item="item">
            <div class="phone_option">
                <span [ngClass]="'phone_flag flag-icon flag-icon-' + item.flag"></span>
                <span>{{ item.name }} ({{ item.dialCode }})</span>
            </div>
        </ng-template>

        <ng-template ng-label-tmp let-item="item">
            <span [ngClass]="'phone_flag flag-icon flag-icon-' + item.flag"></span> {{ item.dialCode }}
        </ng-template>
    </ng-select>
    <input
        maxlength="15"
        [disabled]="isToConsult"
        [id]="id"
        [ngClass]="'form-control'"
        [class.is-invalid]="!isValid && phoneNumber.length !== 0"
        type="tel"
        [(ngModel)]="phoneNumber"
        (input)="onValidate()"
        (blur)="onTouched()"
        inputRestriction="numeric"
    />

</div>
<div *ngIf="phoneNumber && !isValid" class="error">Téléphone invalide</div>